export default __webpack_public_path__ + "static/media/IsometricImg.e2f22505.jpg";